import { useState } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './pages/Hero';
import Products from './pages/Products';
import Scenarios from './pages/Scenarios';
import About from './pages/About';
import Advantages from './pages/Advantages';
import Contact from './pages/Contact';
import Admin from './pages/Admin';

export default function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'admin'>('home');

  // Check if we're on the admin page via URL hash
  if (typeof window !== 'undefined') {
    const hash = window.location.hash;
    if (hash === '#admin' && currentPage !== 'admin') {
      setCurrentPage('admin');
    } else if (hash !== '#admin' && currentPage !== 'home') {
      setCurrentPage('home');
    }
  }

  if (currentPage === 'admin') {
    return <Admin />;
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Products />
        <Scenarios />
        <About />
        <Advantages />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
